"use strict";

require("core-js/modules/es6.string.fixed");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _MobileMenu = _interopRequireDefault(require("./MobileMenu"));

require("./mobile.css");

var Navigation =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Navigation, _React$Component);

  function Navigation() {
    (0, _classCallCheck2["default"])(this, Navigation);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Navigation).apply(this, arguments));
  }

  (0, _createClass2["default"])(Navigation, [{
    key: "getFixedValue",
    value: function getFixedValue() {
      var _this$props = this.props,
          position = _this$props.position,
          fixed = _this$props.fixed;
      if (position === 'side') return 'left';
      if (!this.logoHasOwnRow() && fixed) return 'top';
      return null;
    }
  }, {
    key: "getContainerClassNames",
    value: function getContainerClassNames() {
      var _this$props2 = this.props,
          position = _this$props2.position,
          fixed = _this$props2.fixed,
          backgroundColor = _this$props2.backgroundColor; // create class names

      var classNames = 'navigation-container'; // navigation position

      if (position === 'side') {
        classNames += ' navigation-container-side';
      } else if (position === 'top' && fixed) {
        classNames += ' navigation-container-top-fixed';
      } else {
        classNames += ' navigation-container-top';
      } // colors


      if (backgroundColor === 'primary') {
        classNames += ' navigation-primary-background';
      } else if (backgroundColor === 'secondary') {
        classNames += ' navigation-secondary-background';
      }

      return classNames;
    }
  }, {
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var backgroundColor = this.props.backgroundColor;
      var additionalStyle = backgroundColor !== 'primary' && backgroundColor !== 'none' ? {
        backgroundColor: backgroundColor,
        color: 'white'
      } : {};
      return additionalStyle;
    }
  }, {
    key: "isEvenSpacing",
    value: function isEvenSpacing() {
      var _this$props3 = this.props,
          evenSpacing = _this$props3.evenSpacing,
          position = _this$props3.position,
          logoPosition = _this$props3.logoPosition,
          links = _this$props3.links,
          logo = _this$props3.logo,
          header = _this$props3.header;
      return evenSpacing && position === 'top' && (logoPosition === 'middle' && links.length % 2 === 0 || logoPosition === 'top' || logoPosition === 'bottom') || header.length === 0 && logo.length === 0;
    }
  }, {
    key: "logoHasOwnRow",
    value: function logoHasOwnRow() {
      var logoPosition = this.props.logoPosition;
      return logoPosition === 'top' || logoPosition === 'bottom';
    }
  }, {
    key: "renderPrimaryContent",
    value: function renderPrimaryContent() {
      var _this$props4 = this.props,
          logo = _this$props4.logo,
          header = _this$props4.header;

      if (logo) {
        return _react["default"].createElement(_semanticUiReact.Menu.Item, null, _react["default"].createElement(_semanticUiReact.Image, {
          height: 50,
          src: logo,
          centered: this.logoHasOwnRow()
        }));
      }

      return this.logoHasOwnRow() ? _react["default"].createElement(_semanticUiReact.Header, {
        textAlign: "center",
        as: "h2"
      }, header) : _react["default"].createElement(_semanticUiReact.Menu.Item, {
        header: true
      }, header);
    }
  }, {
    key: "renderMenuItem",
    value: function renderMenuItem(item, index) {
      var _this$props5 = this.props,
          linksAs = _this$props5.linksAs,
          linkComponent = _this$props5.linkComponent;
      var pageTitle = item.pageTitle,
          slug = item.slug,
          internal = item.internal,
          emphasis = item.emphasis,
          inverted = item.inverted;
      var itemText = emphasis ? _react["default"].createElement(_semanticUiReact.Button, {
        inverted: inverted
      }, pageTitle) : pageTitle;
      return _react["default"].createElement(_semanticUiReact.Menu.Item, (0, _extends2["default"])({
        key: index,
        as: internal ? linkComponent : 'a'
      }, internal ? {
        to: slug
      } : {
        href: slug,
        target: '_blank'
      }), linksAs === 'text' ? _react["default"].createElement("span", null, itemText) : _react["default"].createElement(_semanticUiReact.Header, {
        as: linksAs
      }, itemText));
    }
  }, {
    key: "renderMenuItems",
    value: function renderMenuItems() {
      var _this = this;

      var _this$props6 = this.props,
          links = _this$props6.links,
          logoPosition = _this$props6.logoPosition,
          header = _this$props6.header,
          logo = _this$props6.logo; // create navigation links

      var menuItems = links.map(function (link, index) {
        return _this.renderMenuItem(link, index);
      }); // place primary content in correct menu item order

      if (header.length === 0 && logo.length === 0) {
        return menuItems;
      }

      if (logoPosition === 'left' && !this.isEvenSpacing()) {
        return _react["default"].createElement(_react["default"].Fragment, null, this.renderPrimaryContent(), _react["default"].createElement(_semanticUiReact.Menu.Menu, {
          position: "right"
        }, menuItems));
      }

      if (logoPosition === 'middle') {
        var menuItemsLength = menuItems.length;
        var menuItemsPivot = Math.floor(menuItemsLength / 2);
        return [].concat((0, _toConsumableArray2["default"])(menuItems.slice(0, menuItemsPivot)), [this.renderPrimaryContent()], (0, _toConsumableArray2["default"])(menuItems.slice(menuItemsPivot)));
      }

      return menuItems;
    }
  }, {
    key: "renderNavContainer",
    value: function renderNavContainer(child) {
      var _this$props7 = this.props,
          position = _this$props7.position,
          logoPosition = _this$props7.logoPosition;

      if (this.logoHasOwnRow() && position !== 'side') {
        return _react["default"].createElement("div", {
          style: this.getContainerStyle()
        }, _react["default"].createElement(_semanticUiReact.Segment, {
          className: this.getContainerClassNames()
        }, _react["default"].createElement(_react["default"].Fragment, null, logoPosition === 'bottom' && child, this.renderPrimaryContent(), logoPosition === 'top' && child)));
      }

      return _react["default"].createElement("div", {
        className: this.getContainerClassNames(),
        style: this.getContainerStyle()
      }, child);
    }
  }, {
    key: "renderTopNav",
    value: function renderTopNav() {
      var _this$props8 = this.props,
          bordered = _this$props8.bordered,
          links = _this$props8.links,
          position = _this$props8.position; // if primary content lives in own row

      var additionalProps = this.isEvenSpacing() ? {
        widths: !this.logoHasOwnRow() ? links.length + 1 : links.length
      } : {};
      var noBorderStyle = {
        boxShadow: 'none',
        border: 'none'
      };
      return this.renderNavContainer(_react["default"].createElement(_semanticUiReact.Menu, (0, _extends2["default"])({
        stackable: true,
        style: this.logoHasOwnRow() ? noBorderStyle : {},
        vertical: position === 'side',
        borderless: !bordered,
        size: position === 'side' ? '' : 'massive',
        fixed: this.getFixedValue()
      }, additionalProps), this.renderMenuItems()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          position = _this$props9.position,
          logo = _this$props9.logo,
          header = _this$props9.header,
          linksAs = _this$props9.linksAs,
          links = _this$props9.links,
          centerMobileNavItems = _this$props9.centerMobileNavItems,
          linkComponent = _this$props9.linkComponent;
      var nav = position === 'top' ? this.renderTopNav() : this.renderTopNav();
      var mobileLogo = logo ? _react["default"].createElement("img", {
        height: 40,
        src: logo,
        alt: "Logo",
        style: {
          margin: 'auto'
        }
      }) : _react["default"].createElement(_semanticUiReact.Header, {
        as: "h3",
        style: {
          marginTop: 0
        }
      }, header);
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        className: "desktop-nav"
      }, nav), _react["default"].createElement("div", {
        className: "mobile-nav"
      }, _react["default"].createElement(_MobileMenu["default"], {
        centerMobileNavItems: centerMobileNavItems,
        logo: mobileLogo,
        links: links,
        linkComponent: linkComponent,
        linksAs: linksAs,
        className: this.getContainerClassNames()
      })));
    }
  }]);
  return Navigation;
}(_react["default"].Component);

exports["default"] = Navigation;
Navigation.propTypes = {
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    pageTitle: _propTypes["default"].string.isRequired,
    slug: _propTypes["default"].string.isRequired,
    internal: _propTypes["default"].bool.isRequired,
    emphasis: _propTypes["default"].bool,
    inverted: _propTypes["default"].bool
  })).isRequired,
  backgroundColor: _propTypes["default"].string,
  bordered: _propTypes["default"].bool,
  centerMobileNavItems: _propTypes["default"].bool,
  evenSpacing: _propTypes["default"].bool,
  fixed: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  linkComponent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  linksAs: _propTypes["default"].oneOf(['h3', 'h4', 'h5', 'h6', 'text']),
  logo: _propTypes["default"].string,
  logoPosition: _propTypes["default"].oneOf(['top', 'left', 'right', 'middle', 'bottom']),
  position: _propTypes["default"].oneOf(['top', 'side']),
  primaryContentCentered: _propTypes["default"].bool
};
Navigation.defaultProps = {
  backgroundColor: 'primary',
  bordered: false,
  centerMobileNavItems: true,
  evenSpacing: false,
  fixed: false,
  header: '',
  linkComponent: 'a',
  linksAs: 'h4',
  logo: '',
  logoPosition: 'left',
  position: 'top',
  primaryContentCentered: false
};
Navigation.propOptions = {
  backgroundColor: ['primary', 'none']
};
Navigation.dataPropsMap = {};